import React, { useState, useEffect } from 'react';
import { API_BASE } from '../config';
import BikeModal from '../components/BikeModal';

export default function NewBikes() {
  const [bikes, setBikes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [selectedBike, setSelectedBike] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    async function loadNewBikes() {
      try {
        const resp = await fetch(`${API_BASE}/app/bikes`);
        if (!resp.ok) {
          throw new Error(`HTTP error! status: ${resp.status}`);
        }
        const allBikes = await resp.json();
        const filtered = allBikes.filter(b => b.category?.toLowerCase() === 'new');
        setBikes(filtered);
      } catch (err) {
        console.error('Error loading bikes:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }
    loadNewBikes();
  }, []);

  const openDetails = (bike) => {
    setSelectedBike(bike);
    setShowModal(true);
  };

  const closeDetails = () => {
    setSelectedBike(null);
    setShowModal(false);
  };

  return (
    <>
      <div className="page-header">
        <div className="container">
          <h1 className="display-4 fw-bold">Brand New Bikes</h1>
          <p className="lead">2026 latest models with warranty, finance options & free delivery</p>
        </div>
      </div>

      <div className="container py-5">
        {loading ? (
          <div className="row">
            <div className="col-12 text-center py-5">
              <div className="spinner-border text-dark" role="status"></div>
              <p className="mt-2 text-muted">Loading new bikes...</p>
            </div>
          </div>
        ) : (error || bikes.length === 0) ? (
          <div className="row">
            <div className="col-12 text-center text-muted py-5">
              <h4>No new bikes currently listed.</h4>
            </div>
          </div>
        ) : (
          <div className="row g-4">
            {bikes.map(bike => {
              const isSold = bike.status === 'sold';
              const imageUrl = bike.image_url
                ? (bike.image_url.startsWith('http') ? bike.image_url : `${API_BASE}/${bike.image_url}`)
                : 'https://via.placeholder.com/300x200?text=No+Image';

              return (
                <div className="col-md-6 col-lg-4" key={bike.id}>
                  <div className="bike-card card h-100">
                    <div className="sold-container">
                      <img 
                        src={imageUrl} 
                        className={`card-img-top ${isSold ? 'sold-img' : ''}`} 
                        alt={bike.title} 
                        onError={(e) => { e.target.src = 'https://via.placeholder.com/300x200?text=Image+Not+Found'; }}
                      />
                      {isSold && <div className="sold-badge-overlay">Sold Out</div>}
                    </div>
                    <div className="card-body">
                      {bike.badge && <span className="badge-new mb-2">{bike.badge}</span>}
                      <h4 className={`fw-bold ${bike.badge ? 'mt-2' : ''}`}>{bike.title}</h4>
                      <p className="price">{bike.price}</p>
                      {bike.info && <p className="mb-1 fw-semibold text-muted small">{bike.info}</p>}
                      {bike.description ? (
                        <>
                          <p 
                            className="small text-muted mb-1" 
                            style={{
                              display: '-webkit-box',
                              WebkitLineClamp: 3,
                              WebkitBoxOrient: 'vertical',
                              overflow: 'hidden'
                            }}
                          >
                            {bike.description}
                          </p>
                          <button 
                            className="btn btn-link btn-sm p-0 mb-3 text-warning text-decoration-none fw-bold"
                            onClick={() => openDetails(bike)}
                          >
                            Read More
                          </button>
                        </>
                      ) : (
                        <div className="mb-3"></div>
                      )}
                      
                      {isSold ? (
                        <button className="btn btn-secondary rounded-pill w-100 disabled">Sold Out</button>
                      ) : (
                        <a 
                          href={`https://api.whatsapp.com/send?phone=919876543210&text=${encodeURIComponent('Hi, I am interested in ' + bike.title + ' (' + bike.price + ')' + (bike.info ? '\nInfo: ' + bike.info : '') + (bike.description ? '\nDescription: ' + bike.description : ''))}`} 
                          target="_blank" 
                          rel="noopener noreferrer" 
                          className="btn btn-outline-warning rounded-pill w-100"
                        >
                          Enquire Now
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <BikeModal bike={selectedBike} show={showModal} onClose={closeDetails} />
    </>
  );
}
